import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IArxeiaConfiguration } from "../shared/interfaces";

const controller = 'ArxeiaConfigurations';



const getArxeiaConfigurations = (cancelToken?: CancelToken): Promise<IArxeiaConfiguration[]> => {
    return axiosInstance.get(`${controller}/GetArxeiaConfigurations`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateArxeiaConfigurations = (configs: IArxeiaConfiguration[], cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`${controller}/UpdateConfigurations`, configs, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}




export default {
    getArxeiaConfigurations,
    updateArxeiaConfigurations
}